import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import '../freeTalk.css'
import { useAppModule } from '../../appContext.ts'
import { urls } from '../../../shared/urls.ts'
import { TalkScreen } from './talkScreen.tsx'
import { SummaryScreen } from './summaryScreen.tsx'
import { PermissionModal } from './permissionModal.tsx'
import { FtIcon } from './icons.tsx'

export const FREE_TALK_WORDS_ENABLED =
  (import.meta.env.VITE_FREE_TALK_WORDS ?? '1') !== '0'

export function FreeTalkView() {
  const module = useAppModule()
  const navigate = useNavigate()
  const [store] = useState(() => module.freeTalkStore())
  const state = useSnapshot(store.state)

  useEffect(() => {
    void store.open()
    const onVisibility = () => {
      if (document.hidden) store.onHidden()
    }
    document.addEventListener('visibilitychange', onVisibility)
    return () => {
      document.removeEventListener('visibilitychange', onVisibility)
      store.dispose()
    }
  }, [store])

  const goHome = () => {
    navigate(urls.learningProfile())
  }

  return (
    <div className="ft">
      {state.screen === 'talk' ? (
        <TalkScreen
          store={store}
          onClose={() => {
            store.openSummary()
          }}
        />
      ) : (
        <SummaryScreen
          store={store}
          wordsEnabled={FREE_TALK_WORDS_ENABLED}
          onFinish={goHome}
        />
      )}

      {state.screen === 'talk' &&
        !state.started &&
        state.micPerm !== 'granted' && (
          <PermissionModal
            perm={state.micPerm}
            onAllow={() => void store.requestMic()}
            onHome={goHome}
          />
        )}

      <div className={`ft-toast ${state.toast ? 'show' : ''}`} role="status">
        {state.toast && <FtIcon name="check" size={16} stroke={3} />}
        {state.toast}
      </div>
    </div>
  )
}
